module.exports = __webpack_public_path__ + "static/media/undraw_heavy_box_agqi (2).3c3d02ca.png";